/**
 * IK Online - UserprofileService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `INBOX` - Setting for sending documents to the portal inbox. * `INBOX_INFO` - Setting for sending documents to the portal inbox and send a mail with link to it. * `ATTACHMENT` - Setting for sending documents via mail as an attachment. 
 */
export type NotificationSettings = 'INBOX' | 'INBOX_INFO' | 'ATTACHMENT';

export const NotificationSettings = {
    Inbox: 'INBOX' as NotificationSettings,
    InboxInfo: 'INBOX_INFO' as NotificationSettings,
    Attachment: 'ATTACHMENT' as NotificationSettings
};

